import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { isAdmin } from '../utils';

import Route from './SentryRoute';

const AdminRoute = ({ component: Components, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAdmin() ? (
        <Components {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

AdminRoute.defaultProps = {
  location: null,
};

AdminRoute.propTypes = {
  location: PropTypes.instanceOf(Object),
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.instanceOf(Object),
    PropTypes.func,
  ]).isRequired,
};

export default AdminRoute;
